import React from 'react';
import {
	styled,
	ParentBoundComponent,
	Module
} from 'ps-gui';

import {
	CellMainText,
	CellSubText
} from './portalresultsetmodule';

import NotificationAdminModel from './notificationadminmodel';

const Wrapper = styled.div`
`;

export default class NotificationAdminModule extends ParentBoundComponent {

	getModel() {
		return new NotificationAdminModel(this.getData());
	}

	setModel(model) {
		this.setData(model.getData());
	}

	componentDidMount() {
		if (!this.getData().get('initialized')) {
			this.setModel(this.getModel().initialize());
		}
	}

	render() {
		const data = this.getData();
		return (
			<Wrapper>
				<Module
					appState={data.get('esad')}
					onDataChange={newData => {
						this.setData(data.setIn(['esad', 'data'], newData));
					}}
					customResultProps={customResultProps}
				/>
			</Wrapper>
		);
	}
}

const cellRendererMap = Object.freeze({
	'created_when': (cell, row, colIndex) => {
		return (
			<>
				<CellMainText>{cell}</CellMainText>
				<CellSubText>{row.get('created_by')}</CellSubText>
			</>
		);
	},
	'edited_when': (cell, row, colIndex) => {
		return (
			<>
				<CellMainText>{cell}</CellMainText>
				<CellSubText>{row.get('edited_by')}</CellSubText>
			</>
		);
	},
});

const customResultProps = {
	cellRendererMap,
	withNewEntityButton: true,
	columnFilters: {
		'is_deleted': {
			type: 'lookup',
			lookup: 'ynBoolean'
		},
		'comments': {
			type: 'text',
		},
		'notification_channel': {
			type: 'lookup',
			lookup: 'notificationChannel'
		},
		'from_date': {
			type: 'date'
		},
		'to_date': {
			type: 'date'
		},
		'created_when': {
			type: 'date'
		},
		'edited_when': {
			type: 'date'
		},
	}
};

